"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconAssets = function IconAssets(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconAssets', className),
    style: style,
    viewBox: "0 0 18 20"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("path", {
    fill: "none",
    d: "M-4-2h24v24H-4z"
  }), _react.default.createElement("g", {
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.3",
    transform: "translate(1 1)"
  }, _react.default.createElement("rect", {
    width: "14",
    height: "18",
    rx: "1"
  }), _react.default.createElement("g", {
    strokeLinecap: "round"
  }, _react.default.createElement("path", {
    d: "M14 3h2M14 7h2M14 11h2M14 15h2"
  })), _react.default.createElement("path", {
    strokeLinecap: "round",
    d: "M3 6h8M3 12h8"
  }))));
};

var _default = IconAssets;
exports.default = _default;